export default __webpack_public_path__ + "static/media/SENAIT_FR_EPILOGFIN1.ae45a7be.mp3";